import type { NflTeamMeta, Manager } from '../types';

// Single source of truth: 32 NFL teams keyed by ESPN abbreviation.
// Colors are official primary hexes (close enough).
export const NFL_TEAMS: NflTeamMeta[] = [
  // AFC East
  { abbr: 'BUF', city: 'Buffalo', name: 'Bills', conference: 'AFC', division: 'East', color: '#00338D', altColor: '#C60C30', espnId: '2' },
  { abbr: 'MIA', city: 'Miami', name: 'Dolphins', conference: 'AFC', division: 'East', color: '#008E97', altColor: '#FC4C02', espnId: '15' },
  { abbr: 'NE', city: 'New England', name: 'Patriots', conference: 'AFC', division: 'East', color: '#002244', altColor: '#C60C30', espnId: '17' },
  { abbr: 'NYJ', city: 'New York', name: 'Jets', conference: 'AFC', division: 'East', color: '#125740', altColor: '#000000', espnId: '20' },
  // AFC North
  { abbr: 'BAL', city: 'Baltimore', name: 'Ravens', conference: 'AFC', division: 'North', color: '#241773', altColor: '#9E7C0C', espnId: '33' },
  { abbr: 'CIN', city: 'Cincinnati', name: 'Bengals', conference: 'AFC', division: 'North', color: '#FB4F14', altColor: '#000000', espnId: '4' },
  { abbr: 'CLE', city: 'Cleveland', name: 'Browns', conference: 'AFC', division: 'North', color: '#311D00', altColor: '#FF3C00', espnId: '5' },
  { abbr: 'PIT', city: 'Pittsburgh', name: 'Steelers', conference: 'AFC', division: 'North', color: '#FFB612', altColor: '#101820', espnId: '23' },
  // AFC South
  { abbr: 'HOU', city: 'Houston', name: 'Texans', conference: 'AFC', division: 'South', color: '#03202F', altColor: '#A71930', espnId: '34' },
  { abbr: 'IND', city: 'Indianapolis', name: 'Colts', conference: 'AFC', division: 'South', color: '#002C5F', altColor: '#A2AAAD', espnId: '11' },
  { abbr: 'JAX', city: 'Jacksonville', name: 'Jaguars', conference: 'AFC', division: 'South', color: '#101820', altColor: '#D7A22A', espnId: '30' },
  { abbr: 'TEN', city: 'Tennessee', name: 'Titans', conference: 'AFC', division: 'South', color: '#0C2340', altColor: '#4B92DB', espnId: '10' },
  // AFC West
  { abbr: 'DEN', city: 'Denver', name: 'Broncos', conference: 'AFC', division: 'West', color: '#FB4F14', altColor: '#002244', espnId: '7' },
  { abbr: 'KC', city: 'Kansas City', name: 'Chiefs', conference: 'AFC', division: 'West', color: '#E31837', altColor: '#FFB81C', espnId: '12' },
  { abbr: 'LAC', city: 'Los Angeles', name: 'Chargers', conference: 'AFC', division: 'West', color: '#0080C6', altColor: '#FFC20E', espnId: '24' },
  { abbr: 'LV', city: 'Las Vegas', name: 'Raiders', conference: 'AFC', division: 'West', color: '#000000', altColor: '#A5ACAF', espnId: '13' },
  // NFC East
  { abbr: 'DAL', city: 'Dallas', name: 'Cowboys', conference: 'NFC', division: 'East', color: '#003594', altColor: '#869397', espnId: '6' },
  { abbr: 'NYG', city: 'New York', name: 'Giants', conference: 'NFC', division: 'East', color: '#0B2265', altColor: '#A71930', espnId: '19' },
  { abbr: 'PHI', city: 'Philadelphia', name: 'Eagles', conference: 'NFC', division: 'East', color: '#004C54', altColor: '#A5ACAF', espnId: '21' },
  { abbr: 'WSH', city: 'Washington', name: 'Commanders', conference: 'NFC', division: 'East', color: '#5A1414', altColor: '#FFB612', espnId: '28' },
  // NFC North
  { abbr: 'CHI', city: 'Chicago', name: 'Bears', conference: 'NFC', division: 'North', color: '#0B162A', altColor: '#C83803', espnId: '3' },
  { abbr: 'DET', city: 'Detroit', name: 'Lions', conference: 'NFC', division: 'North', color: '#0076B6', altColor: '#B0B7BC', espnId: '8' },
  { abbr: 'GB', city: 'Green Bay', name: 'Packers', conference: 'NFC', division: 'North', color: '#203731', altColor: '#FFB612', espnId: '9' },
  { abbr: 'MIN', city: 'Minnesota', name: 'Vikings', conference: 'NFC', division: 'North', color: '#4F2683', altColor: '#FFC62F', espnId: '16' },
  // NFC South
  { abbr: 'ATL', city: 'Atlanta', name: 'Falcons', conference: 'NFC', division: 'South', color: '#A71930', altColor: '#000000', espnId: '1' },
  { abbr: 'CAR', city: 'Carolina', name: 'Panthers', conference: 'NFC', division: 'South', color: '#0085CA', altColor: '#101820', espnId: '29' },
  { abbr: 'NO', city: 'New Orleans', name: 'Saints', conference: 'NFC', division: 'South', color: '#D3BC8D', altColor: '#101820', espnId: '18' },
  { abbr: 'TB', city: 'Tampa Bay', name: 'Buccaneers', conference: 'NFC', division: 'South', color: '#D50A0A', altColor: '#34302B', espnId: '27' },
  // NFC West
  { abbr: 'ARI', city: 'Arizona', name: 'Cardinals', conference: 'NFC', division: 'West', color: '#97233F', altColor: '#000000', espnId: '22' },
  { abbr: 'LAR', city: 'Los Angeles', name: 'Rams', conference: 'NFC', division: 'West', color: '#003594', altColor: '#FFA300', espnId: '14' },
  { abbr: 'SF', city: 'San Francisco', name: '49ers', conference: 'NFC', division: 'West', color: '#AA0000', altColor: '#B3995D', espnId: '25' },
  { abbr: 'SEA', city: 'Seattle', name: 'Seahawks', conference: 'NFC', division: 'West', color: '#002244', altColor: '#69BE28', espnId: '26' },
];

export const TEAMS_BY_ABBR: Record<string, NflTeamMeta> = NFL_TEAMS.reduce(
  (acc, t) => { acc[t.abbr] = t; return acc; },
  {} as Record<string, NflTeamMeta>
);

export const ALL_TEAM_ABBRS: string[] = NFL_TEAMS.map(t => t.abbr);

export function teamFullName(abbr: string): string {
  const t = TEAMS_BY_ABBR[abbr];
  return t ? `${t.city} ${t.name}` : abbr;
}

export function teamLogoUrl(abbr: string): string {
  // ESPN CDN logos — public, cached
  return `https://a.espncdn.com/i/teamlogos/nfl/500/${abbr.toLowerCase()}.png`;
}

export const STRUCTURED_TEAMS = (() => {
  const out: Record<'AFC' | 'NFC', Record<string, NflTeamMeta[]>> = {
    AFC: { East: [], North: [], South: [], West: [] },
    NFC: { East: [], North: [], South: [], West: [] },
  };
  NFL_TEAMS.forEach(t => { out[t.conference][t.division].push(t); });
  return out;
})();

export const DEFAULT_MANAGERS: Manager[] = [
  { id: 'david', name: 'David', emoji: '🐉', budget: 50, initialBudget: 50, teams: [], teamsDrafted: 0 },
  { id: 'frank', name: 'Frank', emoji: '🦅', budget: 52, initialBudget: 52, teams: [], teamsDrafted: 0 },
  { id: 'rob',   name: 'Rob',   emoji: '👑', budget: 55, initialBudget: 55, teams: [], teamsDrafted: 0 },
  { id: 'ryan',  name: 'Ryan',  emoji: '⚡', budget: 50, initialBudget: 50, teams: [], teamsDrafted: 0 },
];
